import * as React from 'react';
import { connect } from 'react-redux';
import { IAppState } from '../../common/classes/app';

interface StateToProps {
    isMobile: boolean;
}

type FiltersHeaderProps = StateToProps;

export class FiltersHeader extends React.Component<FiltersHeaderProps, null> {
    toggleFilters(e) {
        let filtersTrigger = e.currentTarget as HTMLElement;
        let filtersWrapper = document.getElementById('searchFilters') as HTMLElement;

        if (filtersTrigger.getAttribute('aria-expanded') === 'false') {
            filtersTrigger.setAttribute('aria-expanded', 'true');
            filtersWrapper.setAttribute('aria-hidden', 'false');
        } else {
            filtersTrigger.setAttribute('aria-expanded', 'false');
            filtersWrapper.setAttribute('aria-hidden', 'true');
        }
    }

    render() {
        return (
            <h2 className="adage-search-filters-header">
                <button id="searchFiltersMobileTrigger"
                        type="button"
                        onClick={this.props.isMobile ? this.toggleFilters : null}
                        aria-controls={this.props.isMobile ? "searchFilters" : null}
                        aria-expanded={this.props.isMobile ? "false" : null}>
                    Filters
                </button>
            </h2>
        )
    }
}

function mapStateToProps(state: IAppState): StateToProps {
    return {
        isMobile: state.responsiveState.isMobile
    }
}

export const ConnectedFiltersHeader = connect(mapStateToProps)(FiltersHeader);